<br><br>
<app-gestiones-header-preca [buttonselected]=7 [participante]="participante" [gestionSeleccionada]="gestionSeleccionada" (selecttab)="selectedtab($event)" (selectParticipante)="selectedparticipante($event)"></app-gestiones-header-preca>
<div class="container-fluid">
  <div class="row table-full">
    <div class="table-data" >
    <div class="table4">
      <table class="table table-borderless">
        <thead class="thead-light">
          <tr>
            <th *ngIf="participante==0" colspan="4" scope="col">DATOS GENERALES DEUDOR</th>
            <th *ngIf="participante==1" colspan="4" scope="col">DATOS GENERALES CODEUDOR</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th *ngIf="participante==0">DPI DEUDOR</th>
            <th *ngIf="participante==1">DPI CODEUDOR</th>
            <th>NOMBRE</th>
            <th>NIT</th>
            <th>PASAPORTE</th>
          </tr>
          <tr>
            <td>{{gestionSeleccionada.participante[participante].datosGenerales.dpi}}</td>
            <td>{{gestionSeleccionada.participante[participante].datosGenerales.primerNombre}} {{gestionSeleccionada.participante[participante].datosGenerales.primerApellido}}</td>
            <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.nit}}</td>
            <td></td>
          </tr>
          <tr>
            <th>FECHA DE NACIMIENTO</th>
            <th>REFERENCIA SIB</th>
            <th>PRODUCTO</th>
            <th>USUARIO</th>
          </tr>
          <tr>
            <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.fechaNacimiento}}</td>
            <td>{{ gestionSeleccionada.participante[this.participante].sircRuta12.mensaje !== null
              ? gestionSeleccionada.participante[this.participante].sircRuta12.mensaje.contenido.infgral.referenciaSIB
              : gestionSeleccionada.participante[this.participante].datosGenerales.certificacionSirc}}</td>
            <td>{{gestionSeleccionada.participante[this.participante].codigoSegmentoProducto}}</td>
            <td>{{gestionSeleccionada.informacionGeneral.codigoAbf}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  </div>
</div>
